// removed by extract-text-webpack-plugin
module.exports = {"root":"src-components-About-ScrollBar----index-module---root---3k5md","up":"src-components-About-ScrollBar----index-module---up---3VonJ","down":"src-components-About-ScrollBar----index-module---down---iVbdx","bar":"src-components-About-ScrollBar----index-module---bar---3TWXT","thumb":"src-components-About-ScrollBar----index-module---thumb---1H-t0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/About/ScrollBar/index.module.css
// module id = 448
// module chunks = 213534597649335